export default {"src":"/_next/static/media/arrow-right-blue.f92809e5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};